"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VAlert_vue_1 = __importDefault(require("../scraps/VAlert.vue"));
var VModal_vue_1 = __importDefault(require("../scraps/VModal.vue"));
var VButton_vue_1 = __importDefault(require("../scraps/VButton.vue"));
var DistrictNameInput_vue_1 = __importDefault(require("../form/DistrictNameInput.vue"));
var errors_1 = __importDefault(require("../../config/errors"));
exports.default = vue_1.default.extend({
    name: "create-district-modal",
    components: {
        VAlert: VAlert_vue_1.default,
        VButton: VButton_vue_1.default,
        VModal: VModal_vue_1.default,
        DistrictNameInput: DistrictNameInput_vue_1.default
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            districtName: "",
            invalidDistrictName: false,
            errors: errors_1.default
        };
    },
    methods: {
        onKeyDown: function (keyCode) {
            if (keyCode === 13) {
                this.onDistrictCreate();
            }
        },
        onClose: function () {
            this.invalidDistrictName = false;
            this.districtName = "";
            this.$emit("close");
        },
        onDistrictCreate: function () {
            if (!this.$refs["districtNameInput"].isValid(true)) {
                this.$refs["districtNameInput"].appendValidationClass();
                return;
            }
            this.$emit("createDistrict", this.districtName);
            this.districtName = "";
        }
    }
});
